
export const ApiEndpoints = {
  // Base URLs
  QA: "https://qa-clientvalidation.cashe.co.in",
  PROD: "https://clientvalidation.cashe.co.in",
  STAGE: "https://qa-apigateway.cashe.co.in",

  mockApi1: "https://4d32b4ce-e513-43de-87d2-50c7b23cb2c2.mock.pstmn.io",
  mockApi2: "https://8b347ade-6803-443f-88b6-794af881118f.mock.pstmn.io",
  mockApi3: "https://299684da-4211-453a-90a1-6f13ccbaacbd.mock.pstmn.io",

  mainHost: "qa-collectiondashboard.cashe.co.in",
  // backend base url
  qaBaseUrl: "https://qa-api.bookyourzone.com",
  localUrl: "http://localhost:9000",
  prodBaseUrl: "https://prod-api.bookyourzone.com",
  stageBaseUrl: "https://qa-api.bookyourzone.com",


  //user
  login: "/api/users/login",

  // path specific url
  venuesList: "/api/venue/getAllRegisterVenue",
  getVenueDetails: "/api/venue/getVenueDetails",
  getProfile: "/api/users/getProfile",
  updateUserProfile: "/api/users/updateUserProfile",
  getStaticPlatformFeeConfig: "/api/static-config/getStaticPlatformFeeConfig",
  getCategories: "/api/static-config/getCategories",
  createBooking: "/api/booking/createBooking",
  cancelBooking: "/api/bookingPayment/cancelBooking",
  cancelPendingBooking: "/api/bookingPayment/cancelPendingBooking",
  getMyBookings: "/api/booking/getMyBookings",
  getUserPendingBookings: "/api/booking/getUserPendingBookings",
  verifyPayment: "/api/bookingPayment/verifyPayment",
  getNearbyVenues: "/api/venue/nearby",
  writeReview: "/api/review/writeReview",
  getAllReviews: "/api/review/getAllReviews",

  sendVendorSignupOtpToEmail: "/api/vendor/sendVendorSignupOtpToEmail",
  onboardvendor: "/api/vendor/onboard-vendor",
  vendorusernameandpasswordlogin: "/api/vendor/vendor-username-and-password-login",
  getVendorProfile: "/api/vendor/getVendorProfile",
  updateVendorProfile: "/api/vendor/update-profile",
  sendVendorOTP: "/api/vendor/vendor-send-otp",
  verifyVendorOTP: "/api/vendor/vendor-verify-otp",
  registerNewVenue: "api/venue/registerNewVenue",
  getPendingVenueDetails: "/api/venue/getPendingVenueDetails",
  getCompletedVenueDetails: "/api/venue/getCompletedVenueDetails",
  getStaticConfig: "/api/static-config/getStaticConfig",
  getVendorVenueDetailsById: "/api/venue/getVendorVenueDetailsById",

  venueUpdateById: "api/venue/venueUpdate",
  deleteSportById:"api/venue/deleteSport",
  updateVendorSportAndCourtOnEdit: "api/venue/updateVendorSportAndCourtOnEdit",
  addNewCourtInVendorSports: "api/venue/addNewCourtInVendorSports",
  updateturfImages: "api/venue/updateturfImages",
  deleteImages: "api/venue/deleteImages",
  createOnboardingPaymentOrder: "api/onboardingPayment/createOnboardingPaymentOrder",

  // Monetisation. The venue-scoped routes take /:venueId and, for all but the
  // plan read, a suffix after it, so the builder composes those urls itself.
  monetisationPlans: "/api/monetisation/plans",
  monetisationVenue: "/api/monetisation/venue",
  goLiveQuote: "/api/onboardingPayment/goLiveQuote",

  verifyOnboardingPayment: "api/onboardingPayment/verifyOnboardingPayment",
  getSlotsByDate: "api/venue/getSlotsByDate",
  updateVendorVenueSlots:"api/venue/updateVendorVenueSlots",
  toggleBookingByVenueId:"api/vendor/toggleBooking",
  createwebsite:"api/vendorWebsite/create-website",
  checksubdomain:"api/vendorWebsite/check-subdomain",
  getWebsiteByVendor:"api/vendorWebsite/getWebsiteByVendor",
  vendorDashboardDetails:"api/vendor/vendorDashboardDetails",
  createVendorFundAccount:"api/vendor/createVendorFundAccount",
  validateVendorBankAccount:"api/vendor/validateVendorBankAccount",
  generateForgotPasswrodLinkForVendor:"api/vendor/generateForgotPasswrodLinkForVendor",
  createPaymentOrderForDirectBookingLinkSubscription:"/api/vendor/saas/createPaymentOrderForDirectBookingLinkSubscription",
  verifyDirectBookingLinkSubscriptionPayment:"/api/vendor/saas/verifyDirectBookingLinkSubscriptionPayment",
  getVendorDirectBookingLinkVenuesSubscription:"/api/vendor/saas/getVendorDirectBookingLinkVenuesSubscription",
  getSubscriptionPlanDetails:"/api/vendor/saas/getSubscriptionPlanDetails",
  getVendorPromotions:"/api/recommendation/getVendorPromotions",
  createRecommendation:"/api/recommendation/createRecommendation",
  verifyRecommendationSubscriptionPayment:"/api/recommendation/verifyRecommendationSubscriptionPayment",
  getVendorsBookingsWithPagination:"api/vendor/getVendorsBookingsWithPagination",
  getVendorsBookingsDetailsWithID:"api/vendor/getVendorsBookingsDetailsWithID",
  createManualBooking:"api/vendor/bookings/manual",
  // Direct booking: customer pays the vendor's own UPI/QR. No payment link.
  createDirectBooking:"api/vendor/bookings/direct",
  cancelVendorManualBooking:"api/vendor/bookings/cancelVendorManualBooking",
  getCustomerByPhone:"api/vendor/bookings/getCustomerByPhone",
  getVendorDiscounts:"api/vendor/discount/getVendorDiscounts",
  deleteVendorDiscount:"api/vendor/discount/deleteVendorDiscount",
  toggleVendorDiscount:"api/vendor/discount/toggleVendorDiscount", // /vennueId
  createVendorDiscount:"api/vendor/discount/createVendorDiscount",
  rescheduleBooking:  "api/vendor/bookings/rescheduleBooking",
  previewVendorAgreement:"api/vendor-agreement/preview",            // /venueId=69c4c82ba4ed93c784812fe6"
  checkAgreementStatus:"api/vendor-agreement/checkAgreementStatus",    
};
